import { createSvgIconComponent } from "../utils";
export var IconHomeKitchen = createSvgIconComponent({
  paths: [{
    d: "M8.32 3.6a.46.46 0 0 0-.64 0L2.35 8.78a.43.43 0 0 0-.13.31v3.78a1.63 1.63 0 0 0 1.65 1.61h2.64v-4h3v4h2.64a1.63 1.63 0 0 0 1.65-1.61V9.09a.43.43 0 0 0-.13-.31z"
  }, {
    d: "M15.73 7.3l-2.42-2.35V2.23a.92.92 0 0 0-1.83 0v.94L9.67 1.41a2.46 2.46 0 0 0-3.34 0L.27 7.3a.87.87 0 0 0 0 1.26.94.94 0 0 0 1.3 0l6.06-5.89a.55.55 0 0 1 .74 0l6.06 5.89a.94.94 0 0 0 1.3 0 .87.87 0 0 0 0-1.26"
  }],
  fill: "currentColor",
  viewBox: "0 0 16 16"
});